export { default as GestionAlmacen } from "./GestionAlmacen";

